import { render, staticRenderFns } from "./ProfessorLista.vue?vue&type=template&id=5e3ad59a&"
import script from "./ProfessorLista.vue?vue&type=script&lang=js&"
export * from "./ProfessorLista.vue?vue&type=script&lang=js&"
import style0 from "./ProfessorLista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports